/**
 * Auth Layout - Used for login and OAuth callback pages
 */

import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-kleda-bg-clean flex flex-col">
      {/* Header */}
      <header className="bg-kleda-primary text-white py-md px-lg safe-area-top">
        <div className="max-w-container mx-auto flex items-center justify-center">
          <h1 className="font-heading text-xl font-bold">Kleda Field</h1>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-lg">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="py-md px-lg text-center text-kleda-text-muted text-sm safe-area-bottom">
        <p>© {new Date().getFullYear()} Kleda. Alle rechten voorbehouden.</p>
      </footer>
    </div>
  );
}
